import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

// const apiUrl = process.env.REACT_APP_API_ROOT_URL;
export const orderSlide = createSlice({
    name: "order",
    initialState: {
        orderListData: [],
        orderHistoryData : null,

        placeOrderSuccess: false,
        placeOrderFail: false,
        placeOrderResponseData: null,
        placeOrderErrorDetailData: null,

        updateOrderCustomerSuccess: false,
        updateOrderCustomerFail: false,
    },
    reducers: {
        doGetOrderListSuccess: (state, action) => {
            state.orderListData = action.payload.data;
        },
        doGetOrderListFail: (state, action) => {
            state.orderListData = [];
        },
        doPlaceOrderSuccess: (state, action) => {
            state.placeOrderSuccess = true;
            state.placeOrderFail = false;
            state.placeOrderResponseData = action.payload.data;
        },
        doPlaceOrderFail: (state, action) => {
            state.placeOrderSuccess = false;
            state.placeOrderFail = true;
            state.placeOrderErrorDetailData = action.payload.data;
        },
        doUpdateOrderCustomerSuccess: (state, action) => {
            state.updateOrderCustomerSuccess = true;
            state.updateOrderCustomerFail = false;
        },
        doUpdateOrderCustomerFail: (state, action) => {
            state.updateOrderCustomerSuccess = false;
            state.updateOrderCustomerFail = true;
        },
        doGetOrderHistorySuccess: (state, action) => {
            state.orderHistoryData = action.payload.data;
        },
        doGetOrderHistoryFail: (state, action) => {
            state.orderHistoryData = null;
        },
        resetOrderStateSuccess: (state, action) => {
            state.placeOrderSuccess = action.payload;
            state.placeOrderFail = action.payload;
            state.placeOrderResponseData = null;
            state.placeOrderErrorDetailData = null;
            state.updateOrderCustomerSuccess = action.payload;
            state.updateOrderCustomerFail = action.payload;
        },
    },
});

export const doPlaceOrder = (param) => async (dispatch) => {
    try {
        let url = `/api/customer/order/place`;

        const response = await axios.post(url, param);
        dispatch(doPlaceOrderSuccess(response.data));
    } catch (error) {
        dispatch(doPlaceOrderFail(error.response));
    }
};

export const doUpdateOrderCustomer = (param) => async (dispatch) => {
    try {
        let url = `/api/customer/order/update-customer`;

        const response = await axios.post(url, param);
        dispatch(doUpdateOrderCustomerSuccess(response.data));
    } catch (error) {
        dispatch(doUpdateOrderCustomerFail(error.response));
    }
};

export const doGetOrderHistory = (param) => async (dispatch) => {
    try {
        let url = `/api/customer/order/history`;

        const response = await axios.post(url, param);
        dispatch(doGetOrderHistorySuccess(response.data));
    } catch (error) {
        dispatch(doGetOrderHistoryFail(error.response));
    }
};

export const resetOrderState = () => async (dispatch) => {
    dispatch(resetOrderStateSuccess(false));
 };

export const { 
    doGetOrderListSuccess,
    doGetOrderListFail,
    doPlaceOrderSuccess,
    doPlaceOrderFail,
    doUpdateOrderCustomerSuccess,
    doUpdateOrderCustomerFail,
    doGetOrderHistorySuccess,
    doGetOrderHistoryFail,
    resetOrderStateSuccess,
} = orderSlide.actions;

export const getOrderList = (state) => state.order?.orderListData;
export const getOrderHistoryData = (state) => state.order?.orderHistoryData;

export const getPlaceOrderDetail = (state) => state.order?.placeOrderResponseData;
export const getPlaceOrderErrorDetailData = (state) => state.order?.placeOrderErrorDetailData;
export const getPlaceOrderSuccess = (state) => state.order?.placeOrderSuccess;
export const getPlaceOrderFail = (state) => state.order?.placeOrderFail;

export const getUpdateOrderCustomerSuccess = (state) => state.order?.updateOrderCustomerSuccess;
export const getUpdateOrderCustomerFail = (state) => state.order?.updateOrderCustomerFail;

export default orderSlide.reducer;
